import { useEffect, useState } from "react";
import { MerchantUserModel } from "../../../models/merchantUser";
import axios from "../../../lib/axios";
import {
  DELETE_MERCHANT_USER,
  DELETE_MERCHANT_USER_PROFILE,
  FIND_MANY_MERCHANT_STORE,
  FIND_MANY_MERCHANT_USER,
  FIND_ROLE_AND_PERMISSION,
} from "../../../lib/endpoints/merchantUser";
import { StatusEnum } from "../../../enums/status";
import { FETCH_MORE_DATA_AMOUNT } from "../../../config-global";
import { numberFormat } from "../../../utils/nunberFormat";
import { MerChantModel } from "../../../models/merChantModel";
import { RootState } from "../../../store";
import { useSelector } from "react-redux";

export const useJiffyStaffControllers = () => {
  const [tabValue, setTabValue] = useState<StatusEnum>(StatusEnum.ALL);
  const [dataUser, setDataUser] = useState<MerchantUserModel[]>([]);
  const [branchData, setBranchData] = useState<MerChantModel[]>([]);
  const [branchValue, setBranchValue] = useState<string>(null!);
  const [selectedData, setSelectedData] = useState<MerchantUserModel>(null!);
  const [selectedUserId, setSelectedUserId] = useState<string>(null!);
  const [selectedProfileId, setSelectedProfileId] = useState<string>(null!);

  const [openMenu, setOpenMenu] = useState(null);
  const [openForm, setOpenForm] = useState<boolean>(false);
  const [openDelete, setOpenDelete] = useState<boolean>(false);
  const [loadingData, setLoadingData] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>("");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [loadingDeleteButton, setLoadingDeleteButton] =
    useState<boolean>(false);
    const [dataRole,setDataRole]=useState<any>([]);

  const authData: MerchantUserModel = useSelector(
    (state: RootState) => state?.auth?.data ?? null!
  );

  const handleFetchData = async () => {
    try {
      setLoadingData(true);

      const merchantUserResponse = await axios.get(
        FIND_MANY_MERCHANT_USER + `?merchantId=${authData?.merchantId}`
      );

      const merchantUserData = merchantUserResponse.data?.data;

      const roleAndPermissionResponse = await axios.post(
        FIND_ROLE_AND_PERMISSION
      );
      const roleData = roleAndPermissionResponse.data;
      setDataRole(roleData);

      const branchMerchant = branchData.reduce((obj: any, role: any) => {
        obj[role?.id] = role.nameLa;
        return obj;
      }, {});

      const updatedUserData = merchantUserData.map(
        (user: MerchantUserModel) => {
          const userRole = roleData.find(
            (role: any) => role.id === user.roleId
          );
          return {
            ...user,
            nameEn: branchMerchant[user.merchantId],
            role_type: userRole?.name,
          };
        }
      );

      setDataUser(updatedUserData);
    } catch (err) {
      console.error("An error occurred while fetching data:", err);
    } finally {
      setLoadingData(false);
    }
  };

  const handleDeleteUser = async () => {
    try {
      setOpenMenu(null);
      setLoadingDeleteButton(true);
      await Promise.all([
        axios.delete(DELETE_MERCHANT_USER + selectedUserId),
        axios.delete(DELETE_MERCHANT_USER_PROFILE + selectedProfileId),
      ]);
      await handleFetchData();
      setOpenDelete(false);
    } catch (err: any) {
      try {
        window.alert(err.response.data.message);
      } catch (err2) {
        window.alert("Server error please try again");
      }
    } finally {
      setLoadingDeleteButton(false);
    }
  };

  const handleSelectedBranch = (newValue: string) => {
    setBranchValue(newValue);
  };

  const handleOpenForm = () => {
    setOpenForm(true);
  };

  const handleOpenEditForm = () => {
    setOpenForm(true);
    const getData = dataUser.filter((data) => data.id === selectedUserId)[0];
    setSelectedData(getData);
  };

  const handleCloseForm = () => {
    setOpenForm(false);
    setOpenMenu(null);
    setSelectedData(null!);
  };

  const handleOpenDeleteForm = () => {
    setOpenDelete(true);
  };

  const handleCloseDeleteForm = () => {
    setOpenDelete(false);
    setOpenMenu(null);
  };

  const handleOpenMenu = (event: any, getId: string, proId: string) => {
    setOpenMenu(event.currentTarget);
    setSelectedUserId(getId);
    setSelectedProfileId(proId);
  };

  const onCloseMenu = () => {
    setOpenMenu(null);
  };

  const handleChangePage = (event: any, newPage: any) => {
    setCurrentPage(newPage);
  };

  const handleSearch = (e: any) => {
    setSearchValue(e.target.value);
    setCurrentPage(1);
  };

  const filterDataByStatus: MerchantUserModel[] = dataUser?.filter(
    (item: MerchantUserModel) => {
      if (tabValue === StatusEnum.ALL) {
        return true;
      } else if (tabValue === StatusEnum.ACTIVE) {
        return item?.isBan === false;
      } else if (tabValue === StatusEnum.INACTIVE) {
        return item?.isBan === true;
      } else {
        return false;
      }
    }
  );

  const filterData: MerchantUserModel[] = filterDataByStatus
    ?.filter((item) => item?.roleId === (dataRole?.filter((subItem:any)=>subItem?.role_type==="STAFF")[0]?.id))
    .filter(
      (user) =>
        user?.username?.toLowerCase().includes(searchValue.toLowerCase()) ||
        user?.profile?.lastname
          ?.toLowerCase()
          .includes(searchValue.toLowerCase()) ||
        user?.profile?.firstname
          ?.toLowerCase()
          .includes(searchValue.toLowerCase())
    );

  // const filterData: MerchantUserModel[] = filterDataByStatus;

  const rows: MerchantUserModel[] = filterData?.slice(
    (currentPage - 1) * 10,
    currentPage * 10
  );

  const countPagination = Math.ceil(filterData.length / 10);

  const isSearchNotFound: boolean = !dataUser.length && !!searchValue;

  const ActiveUser = dataUser.filter((user) => user.isBan === false);
  const numberOfActiveUsers = ActiveUser.length;

  const InActiveUser = dataUser.filter((user) => user.isBan === true);
  const numberOfInActiveUsers = InActiveUser.length;

  useEffect(() => {
    handleFetchData();
  }, []);

  return {
    openMenu,
    openForm,
    handleOpenForm,
    handleCloseForm,
    handleOpenMenu,
    onCloseMenu,
    rows,
    handleChangePage,
    handleSearch,
    loadingData,
    handleSetTabStatus: (newValue: StatusEnum) => {
      setTabValue(newValue);
      setCurrentPage(1);
    },
    loadingDeleteButton,
    currentPage,
    handleDeleteUser,
    handleCloseDeleteForm,
    handleOpenDeleteForm,
    handleOpenEditForm,
    openDelete,
    selectedData,
    handleFetchData,
    dataUser,
    countPagination,
    searchValue,
    tabValue,
    setSelectedData,
    isSearchNotFound,
    numberOfActiveUsers,
    numberOfInActiveUsers,
    handleCountIndex: (index: number) =>
      numberFormat(index + 1 + 10 * (currentPage - 1)),
    branchData,
    handleSelectedBranch,
    branchValue,
  };
};
